import { expT } from '../utils/expenseI18n';

/** Matches backend Expense::STAFF_PAY_* */
export const STAFF_PAY_PERMANENT = 'permanent';
export const STAFF_PAY_DAY_WORK = 'day_work';

export function staffPayTypeOptions(lang = 'en') {
  return [
    {
      value: STAFF_PAY_PERMANENT,
      label: expT(lang, 'exp.pay.permanent'),
      hint: expT(lang, 'exp.pay.permanentHint'),
      icon: '📋',
    },
    {
      value: STAFF_PAY_DAY_WORK,
      label: expT(lang, 'exp.pay.dayWork'),
      hint: expT(lang, 'exp.pay.dayWorkHint'),
      icon: '🧱',
    },
  ];
}

/** @deprecated use staffPayTypeOptions(lang) */
export const STAFF_PAY_TYPE_OPTIONS = staffPayTypeOptions('sw');

export function staffPayTypeLabel(value, lang = 'en') {
  const v = String(value || '').toLowerCase();
  const hit = staffPayTypeOptions(lang).find((o) => o.value === v);
  return hit?.label || (v ? v : '—');
}
